<div class="maintenance">
  <img alt="menu logo" src="{{ LOGO }}" class="img__logo" />
  <div class="title__container">
    <h3 class="main-title">Sajt trenutno nije dostupan zbog održavanja</h3>
  </div>
  <p>
    Izvinjavamo se zbog eventualnih neugodnosti koje ovo može prouzrokovati. Radovi su skoro
    završeni i uskoro ćemo biti ponovno online.
  </p>
  <div class="buttons">
    <button class="btn--orange" (click)="navigateToHomePage()">U redu</button>
  </div>
</div>
